import { Box, Text } from "@nulogy/components";
import { NO_DATA_LABEL } from "components/helpers/format";
import React from "react";
import styled from "styled-components";

export default function Field({ children, labelText, defaultValue = NO_DATA_LABEL, ...boxProps }) {
  return (
    <Box marginBottom="x2" {...boxProps}>
      {labelText && <Label>{labelText}</Label>}
      <FieldValue>{children || defaultValue}</FieldValue>
    </Box>
  );
}

function Label({ children }) {
  return (
    <Text className="field-label" fontSize="small" fontWeight="bold" lineHeight="smallTextBase">
      {children}
    </Text>
  );
}

const Value = styled(Text)`
  word-wrap: break-word;
`;

function FieldValue({ children }) {
  return <Value className="field-value">{children}</Value>;
}
